import type { IAsset } from "@netx/core-asset-next/schema";
import {permissionsAllow, type IPermissionsAllowParams} from '../enablers/permissionsAllow';

export {PermissionMatrixName} from '@netx/core-permissions/utils/allows';
export {PermissionName} from '../constants';

interface AssetPermissionCheckerParams extends Omit<IPermissionsAllowParams, 'permissions' | 'permissionMatrix'> {
    asset: Pick<IAsset, 'permissions' | 'permissionMatrix'>;
}

export const assetPermissionChecker = ({
    asset,
    ...rest
}: AssetPermissionCheckerParams) => {
    return permissionsAllow({
        ...rest,
        permissionMatrix: asset.permissionMatrix,
        permissions: asset.permissions,
    })
}